function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { bool, node, string } from "prop-types";
import classNamesMaker from "classnames";
import styles from "./cardListing.module.css";
export var CardListing = function CardListing(props) {
  var children = props.children,
    className = props.className,
    _props$isPush = props.isPush,
    isPush = _props$isPush === void 0 ? false : _props$isPush,
    _props$removeSpacing = props.removeSpacing,
    removeSpacing = _props$removeSpacing === void 0 ? false : _props$removeSpacing;
  var classNames = classNamesMaker(styles["jds-Listing"], _defineProperty({}, styles["jds-Listing--isPush"], isPush), _defineProperty({}, styles["jds-Listing--removeSpacing"], removeSpacing), className);
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames
  }, React.Children.map(React.Children.toArray(children), function (child) {
    return /*#__PURE__*/React.createElement("li", {
      className: styles["jds-Listing__Item"],
      key: child.key
    }, child);
  }));
};
CardListing.propTypes = {
  children: node.isRequired,
  className: string,
  isPush: bool,
  removeSpacing: bool
};